<svelte:options customElement={{ tag: "bt-toggle-button", shadow: "none", }} />

<script lang="ts">
  import Icon from '$shared/icons/Icon.svelte'
  import { onMount } from 'svelte';

  export let putUrl: string = '';
  export let getUrl: string = '';
  export let icon: string = '';
  export let initialValue: Boolean;
  export let trueText: string = 'TRUE';
  export let falseText: string = 'FALSE';
  export let booleanProperty: string = '';

  export let storybookMode = false;

  let buttonText = initialValue && initialValue != 'false' ? trueText : falseText;

  const fetchPut = async() => {
    const response = await fetch(putUrl, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      credentials: 'same-origin',
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
  }

  const fetchGet = async() => {
    const response = await fetch(getUrl, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      credentials: 'same-origin',
    })
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    } else {
      const data = await response.json();
      return data[booleanProperty];
    }
  }

  const handleButtonClicked = () => {
    fetchPut().then(() => {
      fetchGet().then((booleanResponse) => {
        buttonText = booleanResponse ? trueText : falseText;
      })
    })
  }

  onMount(() => {
    fetchGet().then(booleanResponse => {
      buttonText = booleanResponse ? trueText : falseText;
    })
  });

</script>
  <div>
    <button type="button" 
      on:click={handleButtonClicked}
      class="p-4 text-sm bg-neutral-900 text-white hover:text-neutral-900 group">
      <div>
        <span class="font-semibold">
          {#if storybookMode}
            Button text
          {:else}
            {buttonText}
          {/if}
        </span>
      </div>
      {#if icon}
      <span class="ml-4">
          <Icon icon={icon} size="medium"></Icon>
      </span>
      {/if}
    </button>
  </div>

<style>
  button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    max-height: 42px;
    border: 1px solid transparent;
    &:hover {
      border-color: black;
      color: theme('colors.neutral.900');
      background: white;
    }
  }
  button:has(div>span:empty) {
    display: none;
  }
  div {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  @media print {
    button {
      display: none !important;
    }
  }
</style>
